<template>

  <div class="badgeImage grid grid__item_span-12 p0 m0">

    <div class="grid__item_span-9 grid m0 p0 paragraph" v-bind:style="{ color: item.project_badge_text_color }" v-html="item.project_badge_text">
    </div>

    <div class="grid__item_span-2 grid m0 p0 icon">
      <img class="" :src="item.project_badge_image" alt="Blacksheepdesign Achievements" title="Blacksheepdesign Achievements" />
    </div>

  </div>

</template>

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'Badge',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/project/badge.vue